<template>
    <Sheet v-loading="loading.actions['news']">
        <span>
            <h1>公告</h1>
        </span>
        <el-table
                :data="pagedData.map((p, idx) => ({idx : idx + 1, ...p}))"
                empty-text="目前無公告"
                height="620px"
        >
            <el-table-column
                    label="#"
                    prop="idx"
                    width="50"
            >
            </el-table-column>
            <el-table-column
                    label="主旨"
                    width="700px"
            >
                <template #default="{row}">
                    <el-button type="text" @click="onDetail(row)">{{subject(row)}}</el-button>
                </template>
            </el-table-column>
            <el-table-column
                    label="發布時間"
            >
                <template #default="{row}">
                    {{row.range[0]}}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="news.length"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="page => pageChange(page, news)"
        ></el-pagination>
        <el-dialog
                :visible.sync="show"
                :title="title"
                @closed="onClosed"
        >
            <el-divider>公告內文</el-divider>
            <div v-html="content" id="news-content"></div>
            <span v-if="downloads.length">附件下載:</span>
            <div style="margin: 0;padding: 0" v-if="downloads.length">
                <a
                        style="margin: 0;padding: 0"
                        href="#"
                        v-for="(download, idx) in downloads"
                        :key="download.key"
                        type="info"
                        @click.prevent="click(download)"
                >
                    {{`${idx+1}.`}}{{download.fullName}}
                </a>
            </div>
            <el-divider></el-divider>
            <template #footer>
                發布於: {{publishAt}}
            </template>
        </el-dialog>
    </Sheet>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import PagingMixin from '../pagingMixin';
    import UploadMixin from '../uploadMixin';
    import {UploadTypes} from '../constants';
    export default {
        name: 'News',
        data: () => ({
            show: false,
            current: undefined
        }),
        mixins: [PagingMixin, UploadMixin],
        computed: {
            ...mapState('news', ['news']),
            ...mapState(['loading']),
            title(){
                if(this.current){
                    return this.current.subject;
                }
                return '';
            },
            publishAt(){
                if(this.current){
                    return this.current.range[0];
                }
                return '';
            },
            content(){
                if(this.current){
                    return this.current.content;
                }
                return '';
            },
            downloads(){
                if(this.current){
                    return this.current.downloads;
                }
                return [];
            }
        },
        methods:{
            ...mapActions('news', {
                getNews: 'getNewsAction',
            }),
            subject(row){
                return row.top ? `${row.subject}-[置頂]` : row.subject;
            },
            onDetail(row){
                this.current = row;
                this.show = true;
            },
            onClosed(){
                this.current = undefined;
                this.show = false;
            },
            async click(download) {
                await this.download(download);
            }
        },
        watch: {
            news(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
            }
        },
        async created() {
            await this.getNews();
        }
    }
</script>

<style >
    #news-content img{
        max-width: 100%;
    }
</style>